'use client'

import { CSSSlider } from '@/ui/layouts/css-slider/CSSSlider.client'
import type { SliderTabEntryProps, SubEntry } from './SliderTabEntry.client'
import { SliderTabEntry } from './SliderTabEntry.client'

export type SliderTabPanelProps = Pick<
  SliderTabEntryProps,
  | 'isBrand'
  | 'isProduct'
  | 'parentName'
  | 'menuPopinParentCategoryText'
  | 'menuPopinPositionClass'
  | 'selectedCategoryKey'
  | 'setSelectedCategoryKey'
  | 'handleMenuPopinClose'
> & {
  /** Sub-entries (level 2) to render in the CSSSlider */
  entries: SubEntry[]
  /** seoContent of the parent entry — used to generate stable React keys */
  parentSeoContent: string | null | undefined
  /** Animated class string for the panel slide-in/out (computed from menu open state) */
  className: string
}

export function SliderTabPanel({
  entries,
  parentSeoContent,
  className,
  isBrand,
  isProduct,
  parentName,
  menuPopinParentCategoryText,
  menuPopinPositionClass,
  selectedCategoryKey,
  setSelectedCategoryKey,
  handleMenuPopinClose,
}: SliderTabPanelProps) {
  return (
    <div className={className}>
      <CSSSlider gap="none" className="z-base" noScrollbarOnTouchDevices>
        {entries.map((entry) => (
          <SliderTabEntry
            key={`${entry.name}-${parentSeoContent}`}
            entry={entry}
            parentName={parentName}
            isBrand={isBrand}
            isProduct={isProduct}
            menuPopinParentCategoryText={menuPopinParentCategoryText}
            menuPopinPositionClass={menuPopinPositionClass}
            selectedCategoryKey={selectedCategoryKey}
            setSelectedCategoryKey={setSelectedCategoryKey}
            handleMenuPopinClose={handleMenuPopinClose}
          />
        ))}
      </CSSSlider>

      {/* Full-width white background behind the slider */}
      <div
        role="none"
        className="user-select-none pointer-events-none absolute inset-y-0 left-1/2 ml-[-50vw] w-screen bg-white shadow-header group-data-[scrolled-beyond]/header:shadow-none"
      />
    </div>
  )
}
